module.exports = __webpack_public_path__ + "img/编组 3备份_1@2x.40bcd98f.png";